import { Button, CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: { xs: "80%", sm: "40%" },
  maxHeight: "90%",
  overflowY: "auto",
  width: { xs: "90%", md: "680px" },
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "5px",
  margin: "0px 0px",
  p: { xs: 2, md: 5 },
};

interface DeleteItemModalProps {
  open: boolean;
  close: () => void;
  customStyle?: object;
  sx?: object;
  loading: boolean;
  onSubmit: any;
}

export default function DeleteItemModal({
  open,
  close,
  customStyle = {},
  sx = {},
  loading,
  onSubmit,
}: DeleteItemModalProps) {
  return (
    <Modal
      open={open}
      onClose={close}
      aria-labelledby="customer-modal-title"
      aria-describedby="customer-modal-description"
      sx={{ ...sx }}
    >
      <Box sx={{ ...style, ...customStyle }}>
        {/* Modal Title */}
        <Typography sx={{ fontSize: "22px", fontWeight: "600" }}>
          Are you sure you want to Delete this Item?
        </Typography>

        {/* Modal Body */}
        <Box mt={2}>
          <Typography sx={{ fontSize: "17px", fontWeight: "400" }}>
            Doing so will delete all the Item availabilities as well
          </Typography>
        </Box>

        {/* Modal Footer */}
        <Box mt={2} display="flex" justifyContent="flex-end" gap={"10px"}>
          <Button
            sx={{
              width: "150px",
              backgroundColor: "#2E7D32",
              fontWeight: 600,
              color: "#FFF",
              "&:hover": {
                backgroundColor: "#2E7D32",
              },
            }}
            onClick={onSubmit}
          >
            {loading ? (
              <CircularProgress sx={{ color: "white" }} size={20} />
            ) : (
              "Delete"
            )}
          </Button>

          <Button
            variant="outlined"
            sx={{
              width: "150px",
              borderColor: "#000",
              color: "#000",
              fontWeight: 600,
              "&:hover": {
                borderColor: "#000",
                backgroundColor: "#f5f5f5",
              },
            }}
            onClick={close}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
